import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "../../context/ThemeContext";

import { getChartHistoryData } from "../../api/request/dashboard/dashboard";
import { setGlobalSymbolID, setGlobalSymbolsData } from "../../store/Slices/globalSymbolSlice";
import { setSymbol } from "../../store/Slices/symbolSlice";

// import { useSymbolPrices } from '../../context/WebSocketContext';


export const handlerMap = new Map();
export const channelToSubscription = new Map();
export const lastBarsCache = new Map();
export const publishNewTick = (tick, symbolName, symbolId) => {
    try {
        const subscriptionItem = channelToSubscription.get(symbolId);
        const handler = handlerMap.get(symbolId);
        if (subscriptionItem === undefined) {
            return;
        }
        let bar;
        bar = {
            time: tick.ts,
            open: tick.bid,
            high: tick.bid,
            low: tick.bid,
            close: tick.bid,
        };
        handler.callback(bar);
    } catch (error) { }
};
const TradingViewChart = () => {
    const chartContainerRef = useRef(null);
    const { userDetail } = useSelector(state => state.user)
    const configurationData = {
        supported_resolutions: ['1', '5', '15', '30', '60', '240', '1D', '1W', '1M'],
    };
    const { darkMode } = useContext(ThemeContext)
    const { symbols } = useSelector(state => state?.watchlist)
    const { globalSymbol } = useSelector(state => state?.globalSymbol)
    const [tvWidget, setTvWidget] = useState()

    const symbolID = globalSymbol?.id;
    const convertResolution = (tradingViewResolution) => {
        const resolutionsMap = { '1': '1', '5': '2', '15': '3', '30': '4', '60': '5', '240': '6', '1D': '7', '1W': '8', '1M': '9' };
        return resolutionsMap[tradingViewResolution] || null;
    }
    const dispatch = useDispatch();

    useEffect(() => {

        if (!window.TradingView) {
            console.error("❌ TradingView library not loaded!");
            return;
        }
        if (!chartContainerRef.current) return;
        console.log(globalSymbol?.name)
        if (!globalSymbol?.name) {
            console.log(globalSymbol?.name)
            return;
        }
        // if (!tvWidget) {
            const datafeed = {
                onReady: (callback) => {
                    setTimeout(() => { callback(configurationData) }, 0);
                },
                searchSymbols: async (userInput, exchange, symbolType, onResultReadyCallback) => {
                    const searchSymbols = Object.values(symbols)
                    if (searchSymbols.length > 0) {
                        const filteredSymbols = searchSymbols.filter((symbol) => {
                            return symbolType && symbolType !== 'all'
                                ? symbol.description.toLowerCase() === symbolType.toLowerCase() &&
                                symbol.name.toLowerCase().includes(userInput.toLowerCase())
                                : symbol.name.toLowerCase().includes(userInput.toLowerCase())
                        }
                        );
                        const symbolsResult = filteredSymbols.map((symbol) => ({
                            symbol: symbol.name,
                            full_name: symbol.name,
                            description: symbol.description,
                            exchange: '',
                            ticker: symbol.name,
                            type: symbol.description,
                        }));
                        onResultReadyCallback(symbolsResult);
                    }
                },
                resolveSymbol: async (symbolName, onSymbolResolvedCallback, onResolveErrorCallback,) => {
                    const symbol = Object.values(symbols).find(item => item.name === symbolName)
                    const symbolInfo = {
                        symbol: symbol?.name,
                        name: symbol?.name,
                        id: symbol?.id,
                        full_name: symbol?.name,
                        description: symbol?.description,
                        timezone: 'UTC',
                        session: "27x7",
                        ticker: symbol?.name,
                        minmov: 1,
                        pricescale: 100000,
                        has_intraday: true,
                        has_daily: true,
                        has_weekly_and_monthly: true,
                        supported_resolutions: configurationData.supported_resolutions,
                        volume_precision: 2,
                        data_status: 'streaming',
                        exchange: '',
                        listed_exchange: '',
                        format: 'price',
                    }
                    dispatch(setGlobalSymbolsData(symbol))
                    dispatch(setGlobalSymbolID(symbol?.id))
                    dispatch(setSymbol({ symbolId: symbol?.id, symbolName: symbol?.name, bid: symbol?.bid, ask: symbol?.ask }));
                    setTimeout(() => { onSymbolResolvedCallback(symbolInfo); }, 0);
                },
                getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
                    const symbol = Object.values(symbols).find(item => item?.name === symbolInfo?.name)
                    const { from, to, firstDataRequest } = periodParams;
                    const periodParam = convertResolution(resolution);
                    console.log(from, to);
                    if (!periodParam) {
                        console.error("[getBars]: Invalid resolution provided", resolution);
                        onErrorCallback("Invalid resolution");
                        return;
                    }
                    const symbolId = symbol?.id || globalSymbol?.id;
                    if (!symbolId) {
                        console.warn("[getBars]: No symbolId found, returning no data");
                        onHistoryCallback([], { noData: true });
                        return;
                    }
                    const requestBody = { clientId: userDetail?.id?.toString(), symbolId: symbolId.toString(), period: Number(periodParam), from: new Date(from * 1000).toISOString(), to: new Date(to * 1000).toISOString() };
                    try {
                        const { data } = await getChartHistoryData(requestBody)
                        if (data.length === 0 && (resolution === '1' || resolution === '5')) {
                            // If the resolution is 1 or 5 and there's no data, fetch the last 24 hours
                            let HasData = false;
                            for (let i = 0; i <= 4; i++) {
                                let fromDate = from;
                                if (resolution === '1') {
                                    fromDate = from - 21600 * i * i;
                                } else {
                                    fromDate = from - 21600 * i * 4 * i;
                                }
                                const { data: oldData } = await getChartHistoryData({ ...requestBody, from: new Date(fromDate * 1000).toISOString() })
                                if (oldData.length > 0) {
                                    HasData = true;
                                    if (firstDataRequest) {
                                        const lastData = { ...data[data.length - 1] }
                                        lastBarsCache.set(symbolInfo.full_name, { ...lastData });
                                    }
                                    const bars = oldData.map(bar => ({ time: bar.time * 1000, open: bar.open, high: bar.high, low: bar.low, close: bar.close, }));
                                    onHistoryCallback(bars, { noData: false });
                                    break;
                                }
                            }
                            if (!HasData) {
                                onHistoryCallback([], { noData: true });
                            }
                        } else {
                            if (data.length === 0) {
                                onHistoryCallback([], { noData: true });
                            } else {
                                if (firstDataRequest) {
                                    const lastData = { ...data[data.length - 1] }
                                    lastBarsCache.set(symbolInfo.full_name, { ...lastData });
                                    console.log(lastData)
                                }
                            }
                            const bars = data.map(bar => ({ time: bar.time * 1000, open: bar.open, high: bar.high, low: bar.low, close: bar.close, }));
                            onHistoryCallback(bars, { noData: false });
                        }

                    } catch (error) {
                        console.error('[getBars]: Error fetching data', error);
                        onErrorCallback(error);
                    }
                },
                subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
                    const handler = {
                        id: subscriberUID,
                        callback: onRealtimeCallback,
                    };
                    handlerMap.set(symbolInfo.id, handler);
                    console.log(symbolInfo)
                    let subscriptionItem = channelToSubscription.get(symbolInfo.name);
                    if (subscriptionItem) {
                        // Already subscribed to the channel, use the existing subscription
                        subscriptionItem.handlers.push(handler);
                        return;
                    }
                    subscriptionItem = {
                        subscriberUID,
                        resolution,
                        lastDailyBar: lastBarsCache.get(symbolInfo.name),
                        handlers: [handler],
                    };
                    channelToSubscription.set(symbolInfo.id, subscriptionItem);
                },
                unsubscribeBars: (subscriberUID) => {
                    const currencyPair = subscriberUID.split('_#_')[0];
                    handlerMap.delete(currencyPair);
                }
            };
            const accessList = {
                type: 'black',
                tools: [
                    { name: 'VWAP', grayed: false },
                    { name: '52 Week High/Low', grayed: false },
                    { name: 'Heikin Ashi', grayed: false },
                ],
            };
            const widget = new window.TradingView.widget({
                studies_access: accessList,
                autosize: true,
                symbol: globalSymbol?.name || globalSymbol.symbolName,
                interval: "240",
                timezone: "UTC",
                locale: "en",
                range: "12M",
                hide_top_toolbar: false,
                allow_symbol_change: true,
                enable_publishing: false,
                style: "1",
                theme: darkMode ? "dark" : "light",
                container: chartContainerRef.current,
                datafeed: datafeed,
                library_path: "/charting_library_cloned_data/charting_library/",
                studies: ["Moving Average"],
                withdateranges: true,
                hide_side_toolbar: false,
                volumePaneSize: "medium",
                disabled_features: [],
                enabled_features: [],
                overlay: true,
                overrides: {
                    "paneProperties.background": darkMode ? "#151924" : "#ffffff",
                    "paneProperties.vertGridProperties.color": darkMode ? "#2f3b5b" : "#e6e6e6",
                    "paneProperties.horzGridProperties.color": darkMode ? "#2f3b5b" : "#e6e6e6",
                    "scalesProperties.textColor": darkMode ? "#D9D9D9" : "#131722",
                    "scalesProperties.lineColor": darkMode ? "#444" : "#ccc",
                    "scalesProperties.showSymbolLabels": true,
                    "mainSeriesProperties.highLowAvgPrice.highLowPriceLabelsVisible": true,
                },
            });
            setTvWidget(widget)
            // widget.changeTheme(darkMode ? "dark" : "light")
        // } 
        // else {
        //     try {
        //         if (symbols[symbolID]?.name) {
        //             tvWidget.setSymbol(symbols[symbolID]?.name,240,() => {})
        //         }
        //         tvWidget.changeTheme(darkMode ? "dark" : "light")
        //     } catch (err) {
        //         console.error('Error in TradingViewChart useEffect:', err)
        //     }
        // }

        return () => widget.remove();
    }, [globalSymbol, userDetail]);

    useEffect(() => {
        if (!tvWidget) return;
        tvWidget.changeTheme(darkMode ? "dark" : "light");
    }, [darkMode]);

    return (
        <div style={{ height: "100%", width: "100%" }}>
            <div ref={chartContainerRef} style={{ height: "100%", width: "100%", backgroundColor: darkMode ? "#151924" : "#ffffff" }}></div>
        </div>
    );

};

export default TradingViewChart;

